import api from "../api";
import {
  addSnackbarMessage,
  addSuccessSnackbarMessage,
} from "../../Common/_plugin/error-response";

function fetchCourses(context, instanceId) {
  if (!instanceId) {
    addSnackbarMessage({}, "Please select an instance.", true);
    return;
  }
  api
    .fetchCourses(instanceId)
    .then((courseResponse) => {
      const courseList = courseResponse.data;
      api
        .fetchCollegeOfCourses(courseList, instanceId)
        .then((collegeResponse) => {
          const collegeMap = collegeResponse.data;
          const courses = courseList.map((course) => ({
            ...course,
            recruitment_session_name:
              collegeMap[course.id]?.recruitment_session_name,
            recruitment_session_id: collegeMap[course.id]?.id,
            slotId: collegeMap[course.id]?.slotId,
          }));
          context.commit("SET_COURSES", courses);
        })
        .catch((collegeError) => {
          context.commit("SET_COURSES", null);
          addSnackbarMessage(
            {},
            collegeError?.response?.data?.message ||
              collegeError?.response?.data?.data?.message || // fallback for nested
              collegeError.message ||
              "Error while fetching colleges related to moodle courses",
            true
          );
        });
      // context.commit("setCourses", result.data);
    })
    .catch((courseError) => {
      context.commit("SET_COURSES", null);
      addSnackbarMessage(
        {},
        courseError?.response?.data?.message ||
          courseError?.response?.data?.data?.message || // fallback for nested
          courseError.message ||
          "Error while fetching moodle courses",
        true
      );
    });
}

function fetchQuizzesByCourseId(context, { instanceId, courseId }) {
  if (!instanceId || !courseId) {
    addSnackbarMessage(
      {},
      instanceId
        ? "Please select a course."
        : "Courses for this instance are not available as of now. Please try again later!",
      true
    );
    return;
  }

  api
    .fetchQuizzesByCourseId({ instanceId, courseId })
    .then((quizList) => {
      const quizzes = quizList.data.quizzes.map((quiz) => ({
        ...quiz,
        isEditingTime: false,
        timeValue: (quiz.timelimit || 0) / 60,
        timeLimitError: null,
      }));
      context.commit("SET_QUIZZES_BY_COURSE", {
        courseId: courseId,
        quizzes,
      });
    })
    .catch((error) =>
      addSnackbarMessage(
        {},
        error.message || "Error while fetching quizzes of moodle courses",
        true
      )
    );
}

// function fetchQuizConfigurations(context, { instanceId, quizId }) {
//   if (!instanceId || !quizId) {
//     addSnackbarMessage(
//       {},
//       instanceId
//         ? "Please select a quiz."
//         : "Quiz configurations are not available at the moment. Please try again later!",
//       true
//     );
//     return;
//   }

//   api
//     .fetchQuizConfigurations({ instanceId, quizId })
//     .then((configurations) =>
//       context.commit("setQuizConfigurations", configurations.data)
//     )
//     .catch((error) =>
//       addSnackbarMessage(
//         {},
//         error.message ||
//           "Error while fetching configurations of quiz of moodle courses",
//         true
//       )
//     );
// }

function fetchCourseConfigurations(context, { instanceId, courseId }) {
  if (!instanceId || !courseId) {
    addSnackbarMessage(
      {},
      instanceId
        ? "Please select a course."
        : "Course configurations are not available at the moment. Please try again later!",
      true
    );
    return;
  }

  api
    .fetchCourseConfigurations({ instanceId, courseId })
    .then((courseConfigurations) => {
      context.commit("SET_CONFIGURATIONS", courseConfigurations.data);
    })
    .catch((error) =>
      addSnackbarMessage(
        {},
        error.message ||
          "Error while fetching configurations of moodle courses",
        true
      )
    );
}

function updateCourseConfigurations(
  context,
  { instanceId, courseId, settings }
) {
  if (!instanceId || !courseId) {
    addSnackbarMessage(
      {},
      instanceId
        ? "Please select a course to update."
        : "Instance is not available. Please try again later.",
      true
    );
    return;
  }

  settings.gradepass = parseInt(settings.gradepass) || 0;
  delete settings.showsebdownloadlink;
  delete settings.browsersecurity;
  delete settings.timelimit;

  api
    .updateCourseConfigurations({ instanceId, courseId, settings })
    .then((response) => {
      addSuccessSnackbarMessage(
        response.data.message ||
          "Course configurations updated successfully in moodle"
      );
      context.dispatch("fetchCourses", instanceId);
      context.dispatch("fetchQuizzesByCourseId", {
        instanceId,
        courseId,
      });
      context.dispatch("updateSlot", {
        from_time: new Date(settings.timeopen * 1000).toISOString(),
        to_time: new Date(settings.timeclose * 1000).toISOString(),
        course_id: courseId,
        instance_id: instanceId,
      });
    })
    .catch((error) =>
      addSnackbarMessage(
        {},
        error.message || "Error while updating course configurations in moodle",
        true
      )
    );
}

function updateSlot(context, data) {
  const course = context.getters.getCourses.find(
    (course) => course.id === data.course_id
  );

  if (course && course.slotId)
    api
      .updateSlot({
        ...data,
        slotId: course.slotId,
      })
      .then((result) => {
        if (!result.data.status) {
          context.commit("REMOVE_COURSE_SLOT_INFO", data.course_id);
        }
      });
}

function updateQuizTimelimitByQuizId(context, data) {
  if (!data.instanceId || !data.quizId) {
    addSnackbarMessage(
      {},
      data.instanceId
        ? "Please select a quiz."
        : "Instance is not available. Please try again later.",
      true
    );
    return;
  }

  const courseId = data.courseId;
  delete data.courseId;
  api
    .updateQuizTimelimitByQuizId(data)
    .then((result) => {
      addSuccessSnackbarMessage(
        result.data.message ||
          "Quiz timelimit updated successfully in moodle courses"
      );
      context.dispatch("fetchQuizzesByCourseId", {
        instanceId: data.instanceId,
        courseId,
      });
    })
    .catch((error) =>
      addSnackbarMessage(
        {},
        error.message ||
          "Error while updating timelimit of quiz of moodle courses",
        true
      )
    );
}

function duplicateCourse(context, data) {
  api
    .duplicateCourse(data)
    .then((result) => {
      context.dispatch("fetchCourses", data.instanceId);
      addSuccessSnackbarMessage(result.data.message);
    })
    .catch((error) => {
      addSnackbarMessage(
        {},
        error?.message ||
          "Problem while duplicating course. Please try again later!",
        true
      );
    });
}

function deleteCourse(context, data) {
  api
    .deleteCourse(data)
    .then((result) => {
      addSuccessSnackbarMessage(result.data.message);
    })
    .catch((error) => {
      addSnackbarMessage(
        {},
        error?.message ||
          "Problem while deleting course. Please try again later!",
        true
      );
    });
}

function fetchCategories(context, instanceId) {
  if (!instanceId) {
    addSnackbarMessage({}, "Please select an instance.", true);
    return;
  }
  api
    .fetchCategories(instanceId)
    .then((categoryList) => {
      context.commit("SET_CATEGORIES", categoryList.data);
    })
    .catch((categoryError) => {
      context.commit("SET_CATEGORIES", null);
      addSnackbarMessage(
        {},
        categoryError?.response?.data?.message ||
          categoryError?.response?.data?.data?.message || // fallback for nested
          categoryError.message ||
          "Error while fetching categories of moodle courses",
        true
      );
    });
}

function deleteUsersFromCourse(context, data) {
  if (!data.instanceId) {
    addSnackbarMessage({}, "Please select an instance.", true);
    return;
  }

  api
    .deleteUsersFromCourse(data)
    .then((res) => {
      res.data.status == "success"
        ? addSuccessSnackbarMessage(
            res.data.message || "Users deleted successfully"
          )
        : addSnackbarMessage(
            {},
            "Problem while deleting users of moodle course. Please try again later!",
            true
          );
    })
    .catch(() => {
      addSnackbarMessage(
        {},
        "Error while deleting users of moodle course. Please try again later!",
        true
      );
    });
}

export default {
  fetchCourses,
  fetchQuizzesByCourseId,
  // fetchQuizConfigurations,
  fetchCourseConfigurations,
  updateCourseConfigurations,
  updateSlot,
  updateQuizTimelimitByQuizId,
  fetchCategories,
  duplicateCourse,
  deleteUsersFromCourse,
  deleteCourse,
};
